export const TENDENCY={
  //'title': '',
  xAxis: [{
    data: [],
    boundaryGap: false,
    axisTick: {
      show: false
    },
    axisLabel: {
      interval: 0,
      rotate: 0,
      color:'#666666'
    },
    //是否去掉网格线
    splitLine: {
      show: false
    },
    //是否显示网格区域
    splitArea: {
      show: false
    },
    axisLine: {
        lineStyle: {
          color: '#bfbfbf',
          width: 1, //这里是为了突出显示加上的
        }
      }
  }],
  yAxis: {
    splitLine: {
      lineStyle: {
        // 使用深浅的间隔色
        color: ['#0087ED']
      }
    },
    nameTextStyle: {
      color: ['#0087ED']
    },
    axisLine: {
      lineStyle: {
        color: '#bfbfbf',
        width: 1, //这里是为了突出显示加上的
      }
    }
  },
  dataZoom: [{
      show: false,
      flowrealtime: true,
      start: 0,
      endValue: 8,
      minValueSpan: 8
    },
    {
      type: 'inside',
      flowrealtime: true,
      startValue: 0,
      endValue: 8,
      minValueSpan: 8
    }
  ],
  grid: {
    left: '15%',
    right: '4%',
    bottom: '12%',
    top: '3%',
    containLabel: false
  },
  xRotate: 60,
  series: [{
    type: 'line',
    'name': '积极',
    areaStyle: {

    },
    'data': [],
    itemStyle:{
        normal:{
            color:'rgba(26, 255, 209,0.5)'
        }
    }
 
  }, {
    type: 'line',
    'name': '消极',
    areaStyle: {},
    'data': [],
    itemStyle:{
        normal:{
            color:'rgba(255, 153, 128,1)'
        }
    },
    
  },{
    type: 'line',
    'name': '中等',
    areaStyle: {
        
    },
    'data': [],
    itemStyle:{
        normal:{
            color:'rgba(77, 210, 255,0.3)'
        }
    }
  }]

}


// WEBPACK FOOTER //
// ./src/components/sentiment/config/tendency.js